import * as React from "react";
function SvgUnorderedList(props) {
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 9h7a1 1 0 010 2H8a1 1 0 010-2zm0-4h7a1 1 0 010 2H8a1 1 0 010-2zm0 8h7a1 1 0 010 2H8a1 1 0 010-2zM6 6a1 1 0 11-2 0 1 1 0 012 0zm0 4a1 1 0 11-2 0 1 1 0 012 0zm0 4a1 1 0 11-2 0 1 1 0 012 0z" }));
}
export default SvgUnorderedList;
